import { NoPrintTarget } from './components/NoPrintTarget';
import { usePdf } from './hooks/usePdf';
import { usePrint } from './hooks/usePrint';
import { usePrintty } from './hooks/usePrintty';
import { useRemovePrintElement } from './hooks/useRemovePrintElement';
import { useRenderer } from './hooks/useRenderer';

const Printty = () => {};
Printty.usePrint = usePrint;
Printty.usePdf = usePdf;
Printty.usePrintty = usePrintty;
Printty.useRenderer = useRenderer;
Printty.NoPrintTarget = NoPrintTarget;
Printty.useRemovePrintElement = useRemovePrintElement;

export { Printty };
